import { useContext } from 'react'
import { AuthContextType, AuthContext } from '../providers/AuthProvider'

export const useAuth = (): AuthContextType => useContext(AuthContext)
